import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '../../select';
import { UPDATE_NAV_ITEM } from 'store/modules/competition-nav/actions';
import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';
import { getTranslation } from '../../../utils/translations';
import { useCreateRegions } from 'widgets/selection-callout/js/hooks/hooks';

export const RegionNavItem = ({ regions }) => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);

    const regionParent = PULSE.app.common.modifyCountryDisplay(
        nav.location.location
    );

    const items = useCreateRegions(regions, regionParent);

    return (
        <div className="stats-leaders-nav__select competition-nav__competition-select">
            <Select
                items={items}
                itemToString={(item) => item?.name}
                initialSelectedItem={regions?.find(
                    (r) => r.timezone === nav.location.timezone
                )}
                activeItem={regions?.find(
                    (r) => r.timezone === nav.location.timezone
                )}
                label={getTranslation('label.filters.region')}
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        UPDATE_NAV_ITEM.request({
                            navItem: 'location',
                            value: {
                                timezone: selectedItem.timezone,
                                id: selectedItem.id,
                                regionName: selectedItem.name,
                                location: selectedItem.timezone.split('/')[0],
                                region: selectedItem.timezone.split('/')[1]
                            }
                        })
                    );
                }}
            />
        </div>
    );
};

RegionNavItem.propTypes = {
    regions: PropTypes.array
};
